<template>
    <div class="overlay_comp_wrap rsv_history_detail" v-if="isShowPopup">
        <div v-if="isLoading" class="loading_bg" style="z-index: 999; border-radius: 0px;">
            <div class="loading_wrap">
                <div class="loading_obj">
                    <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                    </svg>
                </div>
            </div>
        </div>
        <div class="overlay_comp_title">
            <span>변경내역</span>
            <button class="mgl_auto" @click="hidePopup()"><v-icon>mdi-close</v-icon></button>
        </div>
        <div class="overlay_comp_cont">
            <div class="table2_xyscroll sticky">
                <table class="table2_default pd_small">
                    <thead>
                        <tr>
                            <th width="110px">변경일시</th>
                            <th width="100px">부서</th>
                            <th width="80px">담당자</th>
                            <th width="110px">예약일시</th>
                            <th width="120px">프로그램</th>
                            <th width="120px">예약상태</th>
                            <th width="240px">예약메모</th>
                            <th width="80px">수정자</th>
                        </tr>
                    </thead>
                    <tbody v-if="!isEmpty">
                        <ReservationChangeHistoryItem v-for="history in histories" :key="history._id" 
                            :history="history"/>
                    </tbody>
                    <tbody v-if="isEmpty">
                        <tr>
                            <td class="lgray_txt txt_center" colspan="8">표시할 내용이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { useQueryClient } from '@tanstack/vue-query'
import { v2HReservationFindQueryOptions } from '@/composables/queries/v2hreservation/use-v2-hreservation-find-query'
import  ReservationChangeHistoryItem from './ReservationChangeHistoryItem.vue'

export default{
    setup() {
        const queryClient = useQueryClient()
        return { queryClient }
    },
    components: { ReservationChangeHistoryItem },

    props: {
        selectedReservationID: String,
        isShowChangeHistoryPopup: Boolean
    },
    data() {
        return {
            histories: [],
            isLoading: false
        }
    },
    watch: {
        selectedReservationID: {
            handler: function(newValue) {
                if ((newValue ?? '') == '') { return }
                this.requestFetchReservationChangeHistories()
            }
        },
    },
    computed: {
        isEmpty: function() {
            return (this.histories?.length ?? 0) == 0
        },
        isShowPopup: function() {
            return this.isShowChangeHistoryPopup && (this.selectedReservationID ?? '') != ''
        }
    },
    methods: {
        hidePopup() {
            this.$emit('hideReservationChangeHistory')
        },

        // MAKR: - Network
        async requestFetchReservationChangeHistories() {
            try {
                this.isLoading = true
                let param = {
                    reservationID: this.selectedReservationID,
                    key: 'createdAt',
                    way: -1
                }
                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                this.histories = await this.queryClient.fetchQuery(v2HReservationFindQueryOptions(param))
            } catch (err) {
                console.log("reservation change histories find error :", err)
            } finally {
                this.isLoading = false
            }
        },
    }
}
</script>
